import React, {useState, useEffect, useRef, useMemo} from "react";
import {Card} from "../../components/Card";
import UboldSpinner from "../../ubold-components/UboldSpinner";
import {useObjectFromUrlResourceOrNull} from "../../platform/hooks/PlatformHooks";
import {NavLink} from "react-router-dom";
import AjaxService from "../../platform/ajax/AjaxService";


export function StandardListingPage(props) {
    const listings = useObjectFromUrlResourceOrNull("/api/standard-listing");
    const [importFile, setImportFile] = useState(null);
    const [isImporting, setIsImporting] = useState(false);
    const [importMessage, setImportMessage] = useState(null);
    const [importStatus, setImportStatus] = useState(null);

    const listingRefs = useRef({});

    const hashTargetListingId = useMemo(() => {
        const hash = window.location.hash;
        console.log('Hash detected:', hash);
        if (hash && hash.startsWith('#listing-')) {
            const targetId = hash.substring(9);
            console.log('Target listing ID:', targetId);
            return targetId;
        }
        return null;
    }, []);

    if (listings === null) {
        return <UboldSpinner/>;
    }

    const deleteEntry = (listingId, standardEntryId) => {
        if (window.confirm("Usunąć rekord?")) {
            AjaxService.postJson("/api/standard-editor/" + listingId + "/delete-entry/" + standardEntryId,{})
                .then(response => {
                    alert("Usunięto rekord");
                    window.location.reload();
                })
                .catch(error => {
                    alert("Błąd usuwania rekordu");
                    console.error(error);

                });
        }
    }

    const Listing = React.forwardRef((props, ref) => {
        const isHashTarget = props.listing.id === hashTargetListingId;
        const [opened, setOpened] = useState(isHashTarget);

        console.log('Listing:', props.listing.id, 'isHashTarget:', isHashTarget, 'opened:', opened);

        useEffect(() => {
            if (isHashTarget && ref.current) {
                console.log('Scrolling to listing:', props.listing.id);
                setTimeout(() => {
                    ref.current.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }, 100);
            }
        }, [isHashTarget, ref]);

        const entryToTr = (entry, entryIdx) => {
            const isDefault = props.listing.defaultEntries.some(d => {
                console.log('d', JSON.stringify(d));
                console.log('entry', JSON.stringify(entry));
                return JSON.stringify(d) === JSON.stringify(entry);
            });

            return <tr className={!props.listing.overridable || isDefault ? "" : "bg-light-success"}>
                {entry.map(ee => <td>{ee}</td>)}
                <td>
                    {props.listing.overridable ? <>
                        <button onClick={() => deleteEntry(props.listing.id, props.listing.entriesIdsOnIndexes[entryIdx])} className={"btn btn-xxs btn-outline btn-outline-danger me-2"}>Usuń</button>
                        <NavLink to={"/standard-listing/edit/" + props.listing.id + "/" + entryIdx} className={"btn btn-xxs btn-outline btn-outline-primary"}>Edytuj</NavLink>
                    </> : null}
                </td>
            </tr>
        }

        return <div ref={ref}>
            <Card>
                <div className={"d-flex gap-5"}>
                    <button className={"btn btn-sm btn-outline btn-outline-primary"} onClick={() => setOpened(prev => !prev)}>{opened ? "zwiń" : "rozwiń"}</button>
                    <h3 className={"flex-grow-1"}>{props.listing.name}</h3>
                </div>
                {!!opened && <>
                    {props.listing.supportsAddingRows && <NavLink to={"/standard-listing/edit/" + props.listing.id + "/-1"} className={"btn btn-sm btn-outline btn-secondary mt-2"}>Dodaj rekord</NavLink>}
                    {props.listing.supportsAddingRows && <button onClick={props.forgetOverridesFunc} className={"btn btn-sm btn-outline btn-warning mt-2"}>Wyczyść ręczne zmiany</button>}
                    <div className={"table-responsive"}>
                        <table className={"table table-row-bordered table-row-gray-100 align-middle gs-0 gy-1"}>
                            <thead>
                            <tr className="fw-bolder text-muted">
                                {props.listing.columns.map(h => <th>{h.name}</th>)}
                            </tr>
                            </thead>
                            <tbody>
                            {props.listing.entries.map(((entry, entryIdx) => entryToTr(entry, entryIdx)))}

                            </tbody>

                        </table>
                    </div>
                </>}
            </Card>
        </div>
    });
    const forgetAll = () => {
        if (window.confirm("Usunąć wszystkie wprowadzone zmiany typoszeregów?")) {
            AjaxService.postJson("/api/standard-editor/forget-all", {})
                .then(response => {
                    alert("Usunięto wszystkie nie-domyślne zmiany typoszeregów");
                })
                .catch(error => {
                    alert("Błąd usuwania zmian typoszeregów");
                });
        }
    }
    const forgetOverridesForListing = (listingId) => {
        if (window.confirm("Usunąć wprowadzone zmiany typoszeregu?")) {
            AjaxService.postJson("/api/standard-editor/forget-listing/"+listingId, {})
                .then(response => {
                    alert("Usunięto wszystkie nie-domyślne zmiany typoszeregu");
                })
                .catch(error => {
                    alert("Błąd usuwania zmian typoszeregu");
                });
        }
    }

    const exportEditableStandards = () => {
        AjaxService.downloadAuthenticatedFile('/api/standard-editor/export', 'typoszeregi-export.json')
            .catch(error => {
                console.error(error);
                alert("Błąd eksportu edytowalnych standardów");
            });
    }

    const handleImportFileChange = (e) => {
        if (e.target.files) {
            setImportFile(e.target.files[0]);
        }
        setImportMessage(null);
        setImportStatus(null);
    }

    const handleImport = async () => {
        if (!importFile) return;

        if (!window.confirm("Zaimportować edytowalne standardy z pliku? Operacja zastąpi wszystkie obecne edytowalne standardy wartościami z pliku.")) {
            return;
        }

        setIsImporting(true);
        setImportMessage(null);
        setImportStatus(null);

        const formData = new FormData();
        formData.append('file', importFile);

        try {
            const result = await AjaxService.postFormData('/api/standard-editor/import', formData);

            if (result.status === 'success') {
                setImportStatus('success');
                setImportMessage(result.message || 'Import zakończony pomyślnie');
                setImportFile(null);
                // Odśwież stronę aby pokazać nowe dane
                setTimeout(() => window.location.reload(), 2000);
            } else {
                setImportStatus('error');
                setImportMessage(result.message || 'Błąd podczas importu');
            }
        } catch (error) {
            setImportStatus('error');
            setImportMessage('Błąd połączenia podczas importu');
            console.error('Import error:', error);
        } finally {
            setIsImporting(false);
        }
    }

    return <Card header={"Typoszeregi / standardy"} subHeader={"Typoszeregi / standardy to zestawy informacji zaszyte w aplikacji bez możliwości ich zmiany przez użytkownika"}>
        <p>Uwaga, podczas edytowania typoszeregów nalezy używać "." (kropki) jako separatora dziesiętnego.</p>
        <p>W celu produktywnego zarządzania wieloma wierszami w typoszeregu, można użyć kliku z przyciskiem Ctrl na przycisku dodania lub edycji w celu otwarcia w nowej karcie.</p>
        {listings.map(l => {
            if (!listingRefs.current[l.id]) {
                listingRefs.current[l.id] = React.createRef();
            }
            return <Listing
                key={l.id}
                ref={listingRefs.current[l.id]}
                listing={l}
                forgetOverridesFunc={() => forgetOverridesForListing(l.id)}
            />
        })}
        <hr/>
        <h5>Zarządzanie typoszeregami</h5>
        <div className={"d-flex gap-2 mb-3"}>
            <button className={"btn btn-sm btn-outline btn-outline-danger"} onClick={forgetAll}>Usuń wszystkie nie-domyślne zmiany</button>
            <button className={"btn btn-sm btn-outline btn-outline-info"} onClick={exportEditableStandards}>Eksportuj edytowalne standardy do JSON</button>
        </div>

        <div className={"card bg-light p-3"}>
            <h6 className={"mb-3"}>Import edytowalnych standardów z pliku JSON</h6>
            <div className={"alert alert-warning mb-3"}>
                <strong>Uwaga:</strong> Import całkowicie zastąpi wszystkie edytowalne standardy wartościami z pliku JSON. Ta operacja jest nieodwracalna.
            </div>

            <div className={"mb-3"}>
                <label htmlFor="importFile" className={"form-label"}>Wybierz plik JSON z edytowalnymi standardami:</label>
                <input
                    id="importFile"
                    type="file"
                    className={"form-control"}
                    accept=".json"
                    onChange={handleImportFileChange}
                    disabled={isImporting}
                />
            </div>

            {importFile && (
                <div className={"mb-3"}>
                    <div className={"card bg-white"}>
                        <div className={"card-body"}>
                            <h6>Szczegóły pliku:</h6>
                            <ul className={"list-unstyled mb-0"}>
                                <li><strong>Nazwa:</strong> {importFile.name}</li>
                                <li><strong>Typ:</strong> {importFile.type}</li>
                                <li><strong>Rozmiar:</strong> {(importFile.size / 1024).toFixed(2)} KB</li>
                            </ul>
                        </div>
                    </div>
                </div>
            )}

            {importMessage && (
                <div className={`alert ${importStatus === 'success' ? 'alert-success' : 'alert-danger'} mb-3`}>
                    {importMessage}
                </div>
            )}

            {importFile && (
                <button
                    onClick={handleImport}
                    className={"btn btn-danger"}
                    disabled={isImporting}
                >
                    {isImporting ? (
                        <>
                            <span className={"spinner-border spinner-border-sm me-2"} role="status" aria-hidden="true"></span>
                            Importowanie...
                        </>
                    ) : (
                        <>Importuj standardy z pliku (zastąp edytowalne)</>
                    )}
                </button>
            )}
        </div>
    </Card>;
}

StandardListingPage.propTypes = {}

StandardListingPage.defaultProps = {}

